function DOMready(callback) {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}


$(document).ready(function () {

  $(".featured-list").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  
  
  $(".cart-slider-wrapper").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".filter-wrap").on("click", function () {
    if ($(".filter-wrap ul").hasClass("active")) {
      $(".filter-wrap ul").removeClass("active");
    } else {
      $(".filter-wrap ul").addClass("active");
    }
  });

  $(".filter-wrap li").on("click", function () {
    var index = $(this).index() + 2;
    var popup_index = $(this).index() + 1;
    var value = $(this).text();
    $(".active-value").text(value);
    $(".variant-input:nth-child(" + index + ") input").trigger("click");
    $(".popup-content>div").addClass("hide");
    $(".popup-content>div:nth-child(" + popup_index + ")").removeClass("hide");
  });

  $(".grid-product__content .variant-input").on("click", function () {
    $(this).parent().find(".variant-input").removeClass("active");
    $(this).addClass("active");
  });

  $(".read-more").on("click", function () {
    $(".mobile-des > div").slideToggle();
    if ($(this).text() == "Less") {
      $(this).text("Read more");
    } else {
      $(this).text("Less");
    }
  });

  $(".video-status--true").on("click", function () {
    $(this).addClass("hide");
  });

  setTimeout(function () {
    if ($("lb-upsell-product-page-addon").length < 1) {
      $(".complete-the-look--btn").hide();
    }
  }, 1000);

  $(".dmc-popup-close-button").on("click", function () {
    $("#dmc-ingredients-popup").fadeOut();
  });

  // Close popup when clicking outside of store-locations-inner-inner
  $("#store-locations-popup-inner").on("click", function () {
    $("#store-locations-popup").fadeOut();
    $(".results-inner__image img").attr("src", "");
    $(".results-inner__content p span").text("");
    $(".results-inner__content a").attr("href", "");
  });

  // Prevent popup from closing when clicking inside store-locations-inner-inner
  $(".store-locations-inner-inner").on("click", function (event) {
    event.stopPropagation();
  });

  // Close button functionality
  $(".store-locations-popup-close-button").on("click", function () {
    $("#store-locations-popup").fadeOut();
    $(".results-inner__image img").attr("src", "");
    $(".results-inner__content p span").text("");
    $(".results-inner__content a").attr("href", "");
  });


  





  // Close popup when clicking outside of announcement-bar-inner-inner
  $("#announcement-bar-popup-inner").on("click", function () {
    $("#announcement-bar-popup").fadeOut();
  });

  // Prevent popup from closing when clicking inside store-locations-inner-inner
  $(".store-locations-inner-inner").on("click", function (event) {
    event.stopPropagation();
  });

  // Close button functionality
  $(".announcement-bar-popup-close-button").on("click", function () {
    $("#announcement-bar-popup").fadeOut();
  });



  

  $('.announcement-link').on("click", function (ev) {
    ev.preventDefault();
    $("#announcement-bar-popup").fadeIn();
  });



  // Show popup and populate content when clicking on store-locations__grid-item
  $(".store-locations__grid-item a").each(function () {
    var title = $(this).data("title");
    var address = $(this).data("address");
    var hours = $(this).data("hours");

    $(this).on("click", function (ev) {
      ev.preventDefault();
      $(".store-locations-title--slot").text(title);
      $(".store-locations-left__content--slot").html(address);
      $(".store-locations-right__content--slot").html(hours);
      $("#store-locations-popup").fadeIn();
    });
  });

  $(".pdp-faq-desktop h2").each(function () {
    $(this).on("click", function (ev) {
      ev.preventDefault();
      $(this).toggleClass("open");
      $(this).next().slideToggle();
    });
  });

  $('a[href="#complete-the-look"]').click(function (ev) {
    ev.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("lb-upsell-product-page-addon").offset().top - 100,
      },
      500
    );
  });

  $('a[href="#hot-tips"]').click(function (ev) {
    ev.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".application-tips-section-wrapper").offset().top - 100,
      },
      500
    );
  });

  $('a[href="#ingredients"]').click(function (ev) {
    ev.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".product-description-section").offset().top - 100,
      },
      500
    );
  });

  $('a[href="#reviews"]').click(function (ev) {
    ev.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#judgeme_product_reviews").offset().top - 100,
      },
      500
    );
  });

  $(".collection-description-below .h1").click(function (ev) {
    ev.preventDefault();
    $(this).toggleClass("open");
    $(this).next().slideToggle();
  });

  $(".ingredient-section a").on("click", function () {
    $("#dmc-ingredients-popup").fadeIn();
  });

  $(".grid-product__content [data-variant-input]").on("change", function () {
    const product_id = $(this).data("prodid");
    let selectors =
      "#product-block-" + product_id + " form [data-variant-json]";
    const variantJson = $(selectors);
    if (!variantJson) {
      return;
    }

    const variant = _getVariantFromOptions(
      {
        index: $(this).data("index"),
        value: $(this).val(),
      },
      product_id
    );
    let selectorid = "#product-block-" + product_id + " [data-product-select]";
    $(selectorid).val(variant.id);
    updateInputState(variant, $(this));
    updatePrice(variant, product_id);
    updateVariantName(variant, product_id);
  });

  let formstatus = {
    loading: false,
  };

  $(".product-block form").on("submit", function (evt) {
    evt.preventDefault();
    if (formstatus.loading) {
      return;
    }
    let $this = $(this);
    $("[data-add-to-cart]", $($this)).addClass("btn--loading");
    formstatus.loading = true;
    var data = theme.utils.serialize($this[0]);
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === 422) {
          console.log(data);
        } else {
          var product = data;
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
                addToCartBtn: $("[data-add-to-cart]", $($this)),
              },
            })
          );
          if ($(".product-block").hasClass("cart-item")) {
            location.reload();
          }
        }

        formstatus.loading = false;
        $("[data-add-to-cart]", $($this)).removeClass("btn--loading");
      });
  });
});

let updatePrice = function (variant, product_id) {
  if (variant) {
    let regularprice = "#grid-product__price_" + product_id;
    let original = regularprice + " .grid-product__price--original";
    $(regularprice).html(
      theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)
    );
    if (original) {
      $(original).html(
        theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)
      );
    }
  }
};

let updateVariantName = function (variant, product_id) {
  if (variant) {
    let variant_description = `#VariantDescriptionCollection-${product_id}`;
    $(variant_description).html(variant.title);
  }
};

let _getVariantFromOptions = function (lastSelectedOption, product_id) {
  const availableFullMatch = _getFullMatch(true, product_id);
  const fullMatch = _getFullMatch(false, product_id);
  return availableFullMatch || fullMatch || null;
};

let _getFullMatch = function (needsToBeAvailable, product_id) {
  const currentlySelectedOptions = getCurrentOptions(product_id);
  let selectors = "#product-block-" + product_id + " form [data-variant-json]";
  const variantJson = $(selectors);
  if (!variantJson) {
    return;
  }
  let variantsObject = JSON.parse(variantJson.html());
  const variants = variantsObject;

  return variants.find((variant) => {
    const isMatch = currentlySelectedOptions.every(({ value, index }) => {
      return variant[index] === value;
    });

    if (needsToBeAvailable) {
      return isMatch && variant.available;
    } else {
      return isMatch;
    }
  });
};

let getCurrentOptions = function (id) {
  var result = [];
  let optionselector = $(
    "#customCollectionProductInfo-" + id + " [data-variant-input]"
  );
  $(optionselector).each(function (i, el) {
    var type = el.getAttribute("type");

    if (type === "radio" || type === "checkbox") {
      if (el.checked) {
        result.push({
          value: el.value,
          index: el.dataset.index,
        });
      }
    } else {
      result.push({
        value: el.value,
        index: el.dataset.index,
      });
    }
  });

  // remove any unchecked input values if using radio buttons or checkboxes
  result = theme.utils.compact(result);

  return result;
};

let updateInputState = function (variant, el) {
  return (input) => {
    if (variant === null) return;

    const index = $(el).data("index");
    const value = $(input).val();
    const type = $(input).attr("type");

    if (type === "radio" || type === "checkbox") {
      input.checked = variant[index] === value;
    }
  };
};

// Custom JS
$(function () {
  // Add upsell product to cart
  if ($("#upsell-product-1").length) {
    $("#upsell-product-1 .upsell_product_atc").on("click", function (ev) {
      ev.preventDefault();
      var obj = $(this);
      var product_id = obj.data("product-id");
      var product_qty = obj.data("quantity");
      datas = {
        id: product_id,
        quantity: product_qty,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: datas,
        dataType: "json",
        success: function () {
          var drawer = new theme.CartDrawer();
          $(".cart--upsell-product").hide();
          return drawer.buildCart;
        },
      });
    });
  }

  if ($("#upsell-product-2").length) {
    $("#upsell-product-2 .upsell_product_atc").on("click", function (ev) {
      ev.preventDefault();
      var obj = $(this);
      var product_id = obj.data("product-id");
      var product_qty = obj.data("quantity");
      datas = {
        id: product_id,
        quantity: product_qty,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: datas,
        dataType: "json",
        success: function () {
          var drawer = new theme.CartDrawer();
          $(".cart--upsell-product").hide();
          return drawer.buildCart;
        },
      });
    });
  }

  setTimeout(function () {
    $(".ppa-prod-img").each(function () {
      $(this).attr("src", $(this).attr("src").replace("_200x200", "_600x600"));
    });
  }, 1500);
});

document.addEventListener("ajaxProduct:added", function (evt) {
  amzn("trackEvent", "AddToShoppingCart", evt.detail.product);
});
